export const AVAILABLE_SLOT_DURATIONS = [15, 30, 45, 60];

export const DEFAULT_VALUES = {
  SLOT_DURATION: 60,
  START_TIME: '09:00',
  END_TIME: '18:00',
  SLOT_CAPACITY: 1
};

export const TIME_GENERATION = {
  MAX_ITERATIONS: 100
};
